module.exports = __webpack_public_path__ + "static/css3-c26a73b45b9a801864f13edeb0aa2cfb.png";